// extracted by mini-css-extract-plugin
module.exports = {"qAs":"qA_qAs__1NPMA","content":"qA_content__3tKAh","grid":"qA_grid__3OBUB","list":"qA_list__12-UK","qA":"qA_qA__KNN73"};